<template>
  <b-card>
    <b-row>
      <b-col
        cols="12"
        md="auto"
        class="o-label-sm o-strong text-truncate"
      >
        <h6 style="padding-bottom: 7px;">
          {{ platform.name }}
        </h6>
        <toggle-button
          v-model="platform.inUse"
          class="mb-0 mr-2"
          :height="24"
          :width="60"
          :sync="true"
        />Configure Clients
      </b-col>
      <b-col>
        <b-form-group class="o-field">
          <label
            :for="'platformBaseUrl' + platformIndex"
            :disabled="!platform.inUse"
            class="text-truncate"
          >Base URL</label>
          <b-form-input
            :id="'platformBaseUrl' + platformIndex"
            v-model="platform.baseUrl"
            :disabled="!platform.inUse"
            :required="platform.inUse"
            :state="baseUrlValid"
            placeholder="https://tenant.omnigo.one"
            @blur="handleBaseUrlBlur"
          />
          <div class="invalid-tooltip">
            {{ baseUrlFeedback }}
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <template v-for="(client, clientIndex) in platform.clients">
      <client-detail-short
        :key="'client.id' + clientIndex"
        :platform="platform"
        :platform-index="platformIndex"
        :client="client"
        :client-index="clientIndex"
        :settings="settings"
      />
    </template>
  </b-card>
</template>

<script>
import ClientDetailShort from "@/components/tenants/clients/ClientDetailShort.vue";
export default {
  components: {
    ClientDetailShort
  },
  props: {
    platform: {
      type: Object,
      required: true
    },
    platformIndex: {
      type: Number,
      required: true
    },
    settings: {
      type: Object,
      required: true
    }
  },
  methods:{
    handleBaseUrlBlur() { 
      if (this.platform.inUse && this.platform.name.toUpperCase() == "REPORT EXEC"){
        this.$emit('reportexec-baseurl-changed', this.platform.baseUrl);
      }
    }
  },
  computed: {
    baseUrlValid() {
      return !this.platform.inUse || this.platform.baseUrl.length > 0 ? true : false;
    },
    baseUrlFeedback() {
      return this.baseUrlValid ? "" : "Required";
    }
  },
  watch: {
    "platform.inUse": function(val) {
      if (!val) {
        this.platform.baseUrl = "";
        this.platform.clients.forEach(function(client) {
          client.inUse = false;
        });
      }
    }
  },
}
</script>